export default __webpack_public_path__ + "static/media/profile.0a539610.png";